// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-cls1___56576860f28ca200fa3{/*!*/}.Header-cls2__fb5a987f116cc5090836{display:flex;flex-direction:row;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Header-cls1___56576860f28ca200fa3",
	"cls2": "Header-cls2__fb5a987f116cc5090836 Header-cls1___56576860f28ca200fa3"
};
export default ___CSS_LOADER_EXPORT___;
